module.exports = __webpack_public_path__ + "img/tuanBg.b5f925f6.png";